module.exports = __webpack_public_path__ + "grass-nm.5a228e2f1ef3d31e91f17b3304b3e153.png";